import api from '@/helpers/api'

const API_READ = `/api/merchant/`
const API_UPDATE_COMMERCE = `${API_READ}commerce_site/`
const API_UPDATE = API_READ
const API_CREATE = API_READ
const API_DELETE = API_READ
const API_IMPORT = `${API_READ}import`;
const API_READ_LOGO = `/api/logo/`;
const API_READ_ALL_CORPORATE = `/api/merchant/read/all/corporate-id/`
const API_READ_ALL_BRANCH = `/api/merchant/read/all/branch-id/`

export default {
    namespaced: true,
    state: {
        status: '',
        merchants: [],
        currUser: {},
        errMessage: '',
        meta: {
            limit: 10,
            page: 1,
            total: 1
        },
        filter: {},
        search: {}
    },
    mutations: {
        request(state) {
            state.status = 'loading'
        },
        success(state) {
            state.status = 'success'
        },
        error(state) {
            state.status = 'error'
        },
        read(state, { merchants }) {
            state.merchants = [...merchants]
        },
        read_single_success(state, { merchants }) {
            state.merchants = merchants
        },
        switch_page(state, { meta }) {
            state.meta = { ...meta }
        },
        add_filter(state, { filter }) {
            state.filter = { ...filter };
        },
        clear_filter(state) {
            state.filter = {};
        },
        set_search(state, { search }) {
            state.search = { ...search };
        },
        clear_search(state) {
            state.search = {};
        },
    },
    actions: {
        read({ commit, state }) {

            commit('request')

            const { meta } = state
            const { filter } = state
            const { search } = state

            return new Promise((resolve, reject) => {
                api.request('get', API_READ, { meta, filter, search })
                    .then((result) => {
                        commit('read', { merchants: result.data.data })
                        commit('switch_page', { meta: { ...result.data.meta } })
                        commit('success')
                        // commit('clear_filter');
                        return resolve(result)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    });
            });
        },
        read_single({ commit }, id) {

            commit('request');
            return new Promise((resolve, reject) => {
                api.request('get', `${API_READ}${id}`)
                    .then((result) => {
                        commit('success')
                        return resolve(result.data.data);
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err);
                    });
            });
        },
        delete({ commit, dispatch, state }, id) {

            commit('request');

            // Check if this is the last item on current page (before delete)
            const itemsCount = state.merchants.length;
            const currentPage = state.meta.page;
            const willBeEmpty = itemsCount === 1 && currentPage > 1;

            return new Promise((resolve, reject) => {
                api.request('delete', `${API_DELETE}${id}`)
                    .then((response) => {
                        // If page will be empty after delete, navigate to previous page first
                        if (willBeEmpty) {
                            const newMeta = { ...state.meta, page: currentPage - 1 };
                            commit('switch_page', { meta: newMeta });
                        }

                        // Reload data
                        dispatch('read');
                        commit('success')
                        return resolve(response.data)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err.response.data)
                    });
            });

        },
        update({ commit }, { data }) {

            commit('request');

            return new Promise((resolve, reject) => {
                api.request('put', `${API_UPDATE}${data.id}`, {}, data)
                    .then((request) => {
                        commit('success');
                        return resolve(request)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    });
            });


        },
        update_commerce({ commit }, { data }) {

            commit('request');

            return new Promise((resolve, reject) => {
                api.request('put', `${API_UPDATE_COMMERCE}${data.id}`, {}, data)
                    .then((request) => {
                        commit('success');
                        return resolve(request)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    });
            });


        },
        create({ commit }, { data }) {

            commit('request');

            return new Promise((resolve, reject) => {
                api.request('post', `${API_CREATE}`, {}, data)
                    .then((request) => {
                        commit('success');
                        return resolve(request)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    });
            });


        },
        import({ commit }, { data }) {
            commit('request');
            return new Promise((resolve, reject) => {
                api.request('post', API_IMPORT, {}, data)
                    .then((request) => {
                        commit('success');
                        return resolve(request)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    });
            });
        },
        read_branch_logo({ commit }, id) {

            commit('request');
            return new Promise((resolve, reject) => {
                api.request('get', `${API_READ_LOGO}${id}`)
                    .then((result) => {
                        commit('success')
                        return resolve(result.data.data);
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err);
                    });
            });
        },
        read_all_corporate({ commit }, id) {
            commit('request');
            return new Promise((resolve, reject) => {
                api.request('get', `${API_READ_ALL_CORPORATE}${id}`)
                    .then((result) => {
                        commit('success')
                        return resolve(result.data.data);
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err);
                    });
            });
        },
        read_all_branch({ commit }, id) {
            commit('request');
            return new Promise((resolve, reject) => {
                api.request('get', `${API_READ_ALL_BRANCH}${id}`)
                    .then((result) => {
                        commit('success')
                        return resolve(result.data.data);
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err);
                    });
            })
        }
    },
    getters: {
        merchants: () => state => state.merchants,
    }
}
